import { MaterialIcon } from "ui-widgets";
import {
  SelectChangeEvent,
  Box,
  Paper,
  IconButton,
  Card,
  CardHeader,
  CardContent,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CardActions,
} from "@mui/material";
import ModalControlProps from "models/explorer/modal-control-props";
import React, { useState } from "react";
import CommonSearchInputs from "./common-search-inputs";
import DrawCustomSearch from "./draw-custom-search";
import GoogleMaps from "./google-maps";
import SystemBoundariesAndPoints from "./system-boundaries-points";
import ExplorerSearchButton from "./explorer-search-button";

const headerHeight = ["FAF-nt", "nrdata-orig"].includes(
  process.env.REACT_APP_STYLING_THEME ?? "",
)
  ? 80
  : 48;

function ExplorerModal(modalControlProps: ModalControlProps) {
  const { parentDrawControl } = modalControlProps;
  const [open, setOpen] = useState(true);
  const [search, setSearch] = useState<string>("google");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSearchChange = (event: SelectChangeEvent) => {
    setTimeout(() => {
      // Shouldn't need these try catches but something inside this drawcontrol react package tosses an error but doesn't actually cause any issues
      try {
        for (const key in parentDrawControl?._toolbars?.draw?._modes) {
          const mode = parentDrawControl?._toolbars?.draw?._modes[key];
          if (mode?.handler?._enabled) {
            mode?.handler?.disable();
          }
        }
        parentDrawControl?._toolbars?.edit?._modes?.remove?.handler?.removeAllLayers();
      } catch (error) {
        try {
          parentDrawControl?._toolbars?.edit?._modes?.remove?.handler?.removeAllLayers();
          // console.log(error);
        } catch (stupidError) {
          // console.log(stupidError);
        }
      }
    }, 200);
    setSearch(event.target.value);
  };

  return (
    <Box
      id="map-modal"
      className="leaflet-right"
      sx={{
        top: headerHeight,
        padding: "8px",
        pointerEvents: "auto",
        position: "fixed",
        maxWidth: "95vw",
        zIndex: 1000,
      }}
      onTouchStart={(e) => {
        e.stopPropagation();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
    >
      <Paper
        sx={{
          m: 0,
          width: 40,
          height: 40,
          display: !open ? "inline-flex" : "none",
          visibility: !open ? "visible" : "hidden",
          zIndex: 9999,
          pointerEvents: "auto",
        }}
      >
        <IconButton
          title="Close explorer modal"
          onClick={handleOpen}
          sx={{
            pointerEvents: "auto",
          }}
        >
          <MaterialIcon icon="settings" />
        </IconButton>
      </Paper>
      <Paper
        sx={{
          display: open ? "block" : "none",
          visibility: open ? "visible" : "hidden",
          zIndex: 9999,
          pointerEvents: "auto",
        }}
      >
        <Card>
          <CardHeader
            title={"Explore"}
            sx={{ display: "flex", justifyContent: "space-between" }}
            action={
              <IconButton
                title="Close menu"
                sx={{ p: 0, pointerEvents: "auto" }}
                onClick={handleClose}
              >
                <MaterialIcon icon="close" />
              </IconButton>
            }
          />
          <CardContent>
            <Stack>
              <FormControl fullWidth sx={{ my: 1 }}>
                <InputLabel
                  htmlFor="search-type-select-input"
                  id="search-type-select-label"
                >
                  Search type
                </InputLabel>
                <Select
                  labelId="search-type-select-label"
                  id="search-type-select"
                  inputProps={{ id: "search-type-select-input" }}
                  value={search}
                  label="Search type"
                  onChange={handleSearchChange}
                >
                  <MenuItem value={"google"}>
                    Search using Google place names
                  </MenuItem>
                  <MenuItem value={"system"}>
                    Search using system boundaries and points
                  </MenuItem>
                  <MenuItem value={"draw"}>Search using drawing tools</MenuItem>
                </Select>
              </FormControl>

              {search === "google" ? (
                <GoogleMaps {...modalControlProps} />
              ) : search === "system" ? (
                <SystemBoundariesAndPoints {...modalControlProps} />
              ) : (
                <DrawCustomSearch {...modalControlProps} />
              )}
              <CommonSearchInputs {...modalControlProps} />
            </Stack>
          </CardContent>
          <CardActions>
            <ExplorerSearchButton {...modalControlProps} />
          </CardActions>
        </Card>
      </Paper>
    </Box>
  );
}

export default ExplorerModal;
